
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="结合固定列" fileName="combine-column-fixed.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table
            :scroll-width=&quot;1600&quot;
            :max-height=&quot;500&quot;
            row-key-field-name=&quot;rowKey&quot;
            :fixed-header=&quot;true&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :edit-option=&quot;editOption&quot;
            :row-style-option=&quot;rowStyleOption&quot;
            :virtual-scroll-option=&quot;{enable:true}&quot;
            border-y
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // edit option 可控单元格编辑
                editOption: {
                    // cell value change
                    cellValueChange: ({ row, column }) =&gt; {
                        console.log(&quot;cellValueChange row::&quot;, row);
                        console.log(&quot;cellValueChange column::&quot;, column);
                    },
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 15,
                        align: &quot;center&quot;,
                        fixed: &quot;left&quot;,
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: &quot;col1&quot;,
                        key: &quot;col1&quot;,
                        title: &quot;col1&quot;,
                        width: 50,
                        fixed: &quot;left&quot;,
                        edit: true,
                    },
                    {
                        title: &quot;col2-col3&quot;,
                        fixed: &quot;left&quot;,
                        children: [
                            {
                                field: &quot;col2&quot;,
                                key: &quot;col2&quot;,
                                title: &quot;col2&quot;,
                                width: 50,
                                edit: true,
                            },
                            {
                                field: &quot;col3&quot;,
                                key: &quot;col3&quot;,
                                title: &quot;col3&quot;,
                                width: 50,
                                edit: true,
                            },
                        ],
                    },
                    {
                        title: &quot;col4-col5-col6&quot;,
                        children: [
                            {
                                title: &quot;col4-col5&quot;,
                                children: [
                                    {
                                        field: &quot;col4&quot;,
                                        key: &quot;col4&quot;,
                                        title: &quot;col4&quot;,
                                        width: 130,
                                        edit: true,
                                    },
                                    {
                                        field: &quot;col5&quot;,
                                        key: &quot;col5&quot;,
                                        title: &quot;col5&quot;,
                                        width: 140,
                                        edit: true,
                                    },
                                ],
                            },
                            {
                                title: &quot;col6&quot;,
                                field: &quot;col6&quot;,
                                key: &quot;col6&quot;,
                                width: 140,
                                edit: true,
                            },
                        ],
                    },
                    {
                        title: &quot;col7&quot;,
                        fixed: &quot;right&quot;,
                        children: [
                            {
                                title: &quot;col7-1&quot;,
                                field: &quot;col7&quot;,
                                key: &quot;col7&quot;,
                                width: 50,
                                edit: true,
                            },
                        ],
                    },
                    {
                        field: &quot;col8&quot;,
                        key: &quot;col8&quot;,
                        title: &quot;col8&quot;,
                        width: 50,
                        fixed: &quot;right&quot;,
                        edit: true,
                    },
                ],
                // table data
                tableData: [],
            };
        },

        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 100; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A` + i,
                        col2: `B` + i,
                        col3: `C` + i,
                        col4: `D` + i,
                        col5: `E` + i,
                        col6: `F` + i,
                        col7: `G` + i,
                        col8: `H` + i,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"scroll-width":1600,"max-height":500,"row-key-field-name":"rowKey","fixed-header":true,"columns":_vm.columns,"table-data":_vm.tableData,"edit-option":_vm.editOption,"row-style-option":_vm.rowStyleOption,"virtual-scroll-option":{enable:true},"border-y":""}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // edit option 可控单元格编辑
                editOption: {
                    // cell value change
                    cellValueChange: ({ row, column }) => {
                        console.log("cellValueChange row::", row);
                        console.log("cellValueChange column::", column);
                    },
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 15,
                        align: "center",
                        fixed: "left",
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: "col1",
                        key: "col1",
                        title: "col1",
                        width: 50,
                        fixed: "left",
                        edit: true,
                    },
                    {
                        title: "col2-col3",
                        fixed: "left",
                        children: [
                            {
                                field: "col2",
                                key: "col2",
                                title: "col2",
                                width: 50,
                                edit: true,
                            },
                            {
                                field: "col3",
                                key: "col3",
                                title: "col3",
                                width: 50,
                                edit: true,
                            },
                        ],
                    },
                    {
                        title: "col4-col5-col6",
                        children: [
                            {
                                title: "col4-col5",
                                children: [
                                    {
                                        field: "col4",
                                        key: "col4",
                                        title: "col4",
                                        width: 130,
                                        edit: true,
                                    },
                                    {
                                        field: "col5",
                                        key: "col5",
                                        title: "col5",
                                        width: 140,
                                        edit: true,
                                    },
                                ],
                            },
                            {
                                title: "col6",
                                field: "col6",
                                key: "col6",
                                width: 140,
                                edit: true,
                            },
                        ],
                    },
                    {
                        title: "col7",
                        fixed: "right",
                        children: [
                            {
                                title: "col7-1",
                                field: "col7",
                                key: "col7",
                                width: 50,
                                edit: true,
                            },
                        ],
                    },
                    {
                        field: "col8",
                        key: "col8",
                        title: "col8",
                        width: 50,
                        fixed: "right",
                        edit: true,
                    },
                ],
                // table data
                tableData: [],
            };
        },

        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 100; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A` + i,
                        col2: `B` + i,
                        col3: `C` + i,
                        col4: `D` + i,
                        col5: `E` + i,
                        col6: `F` + i,
                        col7: `G` + i,
                        col8: `H` + i,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  